import Cookies from 'js-cookie';

export default function initSlideout() {
    const slideOuts = document.getElementsByClassName('slide-out-toast');
    for (let slideOut of slideOuts) {
        if (
            !Cookies.get(slideOut.getAttribute('id') + '-dismissed') &&
            !slideOut.hasAttribute('data-slideout-initialized')
        ) {
            slideOut.classList.add('show');
            slideOut.addEventListener('click', (e) => {
                const target = e.target;
                if (isElement(target, 'close')) {
                    slideOut.classList.remove('show');
                    Cookies.set(slideOut.getAttribute('id') + '-dismissed', true);
                } else if (isElement(target, 'slide-out-header')) {
                    const slideOutBodies = slideOut.getElementsByClassName('slide-out-body');
                    if (slideOutBodies.length > 0) {
                        slideOutBodies[0].classList.toggle('hidden');
                    }
                }
            });
            slideOut.setAttribute('data-slideout-initialized', 'true');
        }
    }

    function isElement(element, className) {
        return element.classList.contains(className) || element.closest(`.${className}`);
    }
}
